import { observer } from 'mobx-react-lite'

import { EventIcon, TextArea } from 'components'
import { useValueContext } from 'contexts'
import { FlexLayout } from 'layouts'

import { TimeInputs } from '../../components'
import { iconProps } from '../consts'
import './styles.scss'

export const Poo = observer(() => {
  const { eventStore } = useValueContext()
  const { event, setEventField } = eventStore

  return (
    <>
      <div className="page-title event-title">Ка-ка</div>

      <FlexLayout.Content className="scrollable-layout event-scrollable" scrollable>
        <div className="poo-event">
          <div className="type-icons">
            <EventIcon iconName="PoopIcon" {...iconProps} />
          </div>
          <div className="poo-form">
            <TimeInputs
              label="Время"
              value={event?.startTime}
              onChange={(value: string) => setEventField('startTime', value)}
              eventType="START"
            />
            <TextArea
              className="event-textarea"
              label="Комментарий"
              value={event?.comment}
              onChange={(value: string) => setEventField('comment', value)}
              scrollToOnFocus
            />
          </div>
        </div>
      </FlexLayout.Content>
    </>
  )
})
